import { Injectable } from '@angular/core';
import { ProductListComponentService, ProductListRouteParams } from '@spartacus/storefront';

const itemsPerPage = 18;

@Injectable({
  providedIn: 'root',
})
export class CustomProdListService extends ProductListComponentService {
  protected readonly NAME_ALLCATEGORIES = ':name-asc:allCategories:';
  defaultPageSize = itemsPerPage;

  protected getQueryFromRouteParams({ query, categoryCode, brandCode }: ProductListRouteParams) {
    if (query) {
      return query;
    }
    if (categoryCode) {
      return this.NAME_ALLCATEGORIES + categoryCode;
    }
    if (brandCode) {
      return this.NAME_ALLCATEGORIES + brandCode;
    }
  }
}
